import { ISubscriptionItem } from "../../interfaces/ISubscription";

type Props = {
  item: ISubscriptionItem;
}

const SubscriptionItem = ({ item }: Props) => {
  return (
    <div key={item.id}>
      <p className="font-medium text-lg text-black">{item.name}</p>
    </div>
  );
}

export default SubscriptionItem;
